import React, { useState } from "react";
import { motion } from "framer-motion";
import InputGroup from "./InputGroup";
import Result from "./Result";
import Spinner from "./Spinner";

function Calculator() {
  const [percentage, setPercentage] = useState(75);
  const [present, setPresent] = useState("");
  const [total, setTotal] = useState("");
  const [output, setOutput] = useState(null);
  const [currentAttendance, setCurrentAttendance] = useState(null);
  const [loading, setLoading] = useState(false);

  const calculateAttendance = () => {
    const presentInt = parseFloat(present);
    const totalInt = parseFloat(total);
    const percentageInt = parseInt(percentage);

    if (isNaN(presentInt) || isNaN(totalInt) || presentInt < 0 || totalInt <= 0 || presentInt > totalInt) {
      setOutput({ type: "error", message: "Please enter valid numbers!" });
      setCurrentAttendance(null);
      return;
    }

    setLoading(true);
    setTimeout(() => {
      const attendance = ((presentInt / totalInt) * 100).toFixed(2);
      setCurrentAttendance(attendance);

      if (presentInt / totalInt >= percentageInt / 100) {
        const daysAvailableToBunk = Math.floor((100 * presentInt - percentageInt * totalInt) / percentageInt);
        setOutput({
          type: "bunk",
          message: `You can bunk for ${daysAvailableToBunk} more hours.`,
        });
      } else {
        const attendanceNeeded = Math.ceil((percentageInt * totalInt - 100 * presentInt) / (100 - percentageInt));
        setOutput({
          type: "attend",
          message: `You need to attend ${attendanceNeeded} more hours to reach ${percentageInt}% attendance.`,
        });
      }

      setLoading(false);
    }, 500);
  };

  return (
    <div className="bg-gray-50 rounded-2xl shadow-xl p-12 w-full max-w-xl mx-auto">
      <h2 className="text-2xl font-semibold text-gray-700 mb-8 text-center">
        Calculate Your Attendance
      </h2>
      <InputGroup
        percentage={percentage}
        setPercentage={setPercentage}
        present={present}
        setPresent={setPresent}
        total={total}
        setTotal={setTotal}
        onCalculate={calculateAttendance}
      />
      {loading && <Spinner />}
      {output && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mt-8"
        >
          {currentAttendance && (
            <div className="text-center text-gray-600 text-lg mb-6">
              Current Attendance: <strong>{currentAttendance}%</strong>
            </div>
          )}
          <Result output={output} />
        </motion.div>
      )}
    </div>
  );
}

export default Calculator;
